<template>
  <div class="scrollbar">
    <div class="mdl-card__title">
      <h4 class="mdl-card__title-text">{{title}}</h4>
    </div>
    <div class="mdl-card__supporting-text scrollbar">
      {{{text}}}
    </div>
  </div>
</template>
<script>
  var getters = require('common/store/getters')
  var label = require('vue').filter('label')
  module.exports = {
    vuex: {
      getters: getters
    },
    props: {
      service: String
    },
    computed: {
      title: function () {
        return label(this.service.toLowerCase() + '.faq.label.title')
      },
      text: function () {
        return label(this.service.toLowerCase() + '.faq.text')
      }
    }
  }
</script>

<style scoped>
@media only screen and (max-width: 840px) {
  .mdl-tabs__panel>.scrollbar {
    max-height: 400px;
  }
}
@media only screen and (min-width: 840px){
  .mdl-tabs__panel>.scrollbar {
    max-height: 750px;
  }
}
</style>


// WEBPACK FOOTER //
// FAQ.vue?013cae4f